import axios from 'axios';
import * as React from 'react';
import { App } from '../../App';
import { MarkersMap, IMapElement } from '../../modules';
import { Station, StationFactory } from '../../resource/'; 
import { IAuthProps, Query } from '../../services/';
import { MapStationsPopup } from './MapStationsPopup';

interface IProps {
  query: Query;
  onClick?: (station:Station) => void;
  time: number;
}

interface IState {
  elements: IMapElement[];
}

class MapStations extends React.Component<IAuthProps & IProps, IState> {
  constructor(props: IAuthProps & IProps) {
    super(props);
    this.state = {
      elements: []
    }
  }

  private loadStations = (bounds: L.LatLngBounds, zoom: number) => {
    StationFactory.getMap(this.props.auth, this.props.query, bounds, zoom)
    .then(response => {
      this.setState({
        elements: response
      });
    });
  }

  private handleChange = (bounds: L.LatLngBounds, zoom: number) => {
    this.loadStations(bounds, zoom);
  }

  render = () => {
    let p = this.props;
    return (
      <MarkersMap 
        time={this.props.time}
        onChange={this.handleChange}
        elements={this.state.elements}
        popup={(item:Station) => <MapStationsPopup station={item} onClick={p.onClick}/>}/>
    );
  }
}

export { MapStations }
